import { render, staticRenderFns } from "./BuildingDialog.vue?vue&type=template&id=c27980ca&scoped=true&"
import script from "./BuildingDialog.vue?vue&type=script&lang=js&"
export * from "./BuildingDialog.vue?vue&type=script&lang=js&"
import style0 from "./BuildingDialog.vue?vue&type=style&index=0&id=c27980ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27980ca",
  null
  
)

export default component.exports